export const NOTI_PRIORITY_LOW = { id: 1, label: 'Low Priority' }
export const NOTI_PRIORITY_HIGH = { id: 2, label: 'High Priority' }
export const NOTI_PRIORITY_URGENT = { id: 3, label: 'Urgent Priority' }
export const NOTI_PRIORITY_EMERGENCY = { id: 4, label: 'Emergency Priority' }
